// extracted by mini-css-extract-plugin
export default {"LegalInformation":"LegalInformation_LegalInformation__i6YM6","container":"LegalInformation_container__zUTQk","text":"LegalInformation_text__gKqTB"};